import { h, Component } from "preact";
import { Router } from "preact-router";
import { Provider } from "react-redux";
import queryString from "query-string";
import "./utils/PolyFill";
import create from "./state/store";
import Home from "./routes/home";
import AboutUs from "./routes/aboutus/AboutUs";
import SearchResultsPage from "./routes/searchResults/SearchResultsPage";
import FindEventsPage from "./routes/findEvents/FindEventsPage";
// import Pricing from "./routes/pricing/Pricing";
//import OurProjects from "./routes/ourProjects/OurProjects";
import OzHarvest from "./routes/ourImpact/Projects/OzHarvest";
import RoomToRead from "./routes/ourImpact/Projects/RoomToRead";
import Yalari from "./routes/ourImpact/Projects/Yalari";
import KidsCan from "./routes/ourImpact/Projects/KidsCan";
import OurImpact from "./routes/ourImpact/OurImpact";
import NotFoundPage from "./routes/404/404";
import SEOSearchPage from "./routes/seoSearchPage/SEOSearchPage";
import ZipMoney from "./routes/zipMoney/ZipMoney";
import OurStories from "./routes/ourStories/OurStories";
import ContactUs from "./routes/contactUs/ContactUs";
import BuyerSupport from "./routes/contactUs/buyerSupport/BuyerSupport";
import GeneralSupport from "./routes/contactUs/generalSupport/GeneralSupport";
import OrganiserSupport from "./routes/contactUs/organiserSupport/OrganiserSupport";
import CountryDetect from "./components/CountryDetect";
import Redirect from "./utils/Redirect";
import Manaiakalani from "./routes/ourImpact/Projects/Manaiakalani";
import config from "./config";
import IframeTest from "./routes/stagingDebugRoutes/IframeTest";
import FeaturesAndPricing from "./routes/featuresAndPricing/FeaturesAndPricing";
import Share from "./components/navigation/Share";

const env = config("ENV");

if (module.hot) {
  require("preact/debug");
}

export default class App extends Component {
  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */
  routeChanged = false;
  handleRoute = e => {
    this.currentUrl = e.url;
    // hack to get zip money to init since they do not have a function we can call
    if (this.routeChanged && e.url === "/zipmoney") {
      if (typeof window !== "undefined") {
        window.location.reload();
      }
    } else if (e.url !== "/zipmoney") {
      this.routeChanged = true;
    }
    try {
      if (typeof window !== "undefined") {
        window.scrollTo(0, 0);
      }
    } catch (e) {}
  };

  saveReferralCode = referralCode => {
    if (typeof window !== "undefined" && referralCode) {
      const date = new Date();
      const expires = new Date(date.getTime() + 30 * 60000);
      document.cookie = `referralcode=${referralCode}; expires=${expires.toUTCString()}; path=/;`;
    }
  };

  getReferralCode = () => {
    let referralCode;
    document.cookie.split(";").filter(item => {
      if (item.trim().indexOf("referralcode=") == 0) {
        referralCode = item.trim();
      }
    });
    return referralCode;
  };

  render({ url = "/", referralCode }) {
    let locale = "au";
    let detectedLocale = "au";
    if (typeof window !== "undefined") {
      url =
        window && window.location && window.location.pathname
          ? window.location.pathname
          : url;
      if (typeof window !== "undefined" && window.__PRELOADED_STATE__) {
        url = window.__PRELOADED_STATE__.url
          ? window.__PRELOADED_STATE__.url
          : url;
        locale = window.__PRELOADED_STATE__.locale
          ? window.__PRELOADED_STATE__.locale
          : locale;
        detectedLocale = window.__PRELOADED_STATE__.detectedLocale
          ? window.__PRELOADED_STATE__.detectedLocale
          : detectedLocale;
        referralCode = window.__PRELOADED_STATE__.referralCode
          ? window.__PRELOADED_STATE__.referralCode
          : referralCode;
      }
      //yeet
      const search =
        typeof window !== "undefined" ? window.location.search : "";
      if (referralCode) {
        this.saveReferralCode(referralCode);
      } else {
        referralCode = this.getReferralCode();
      }
      //debugging for nz
      window.getLocale = () => {
        console.log(`locale: ${locale}, detectedtLocale: ${detectedLocale}`);
      };
    }

    const store = create({
      referralCode: referralCode,
      widget: url.includes("w=true")
    });

    return (
      <Provider store={store}>
        <div id="app">
          <Share />
          <CountryDetect locale={locale} detectedLocale={detectedLocale} />
          <Router onChange={this.handleRoute} url={url}>
            <Home path="/:locale/" />
            <AboutUs path="/:locale/about-us" />
            <FindEventsPage path="/:locale/find-events" />
            <SearchResultsPage path="/:locale/search" />
            <FeaturesAndPricing path="/:locale/features-and-pricing" />
            <ZipMoney path="/:locale/zipmoney" />
            <OurStories path="/:locale/our-stories" />
            <BuyerSupport path="/:locale/contact-us/buyer-support" />
            <OrganiserSupport path="/:locale/contact-us/organiser-support" />
            <GeneralSupport path="/:locale/contact-us/general-support" />
            <ContactUs path="/:locale/contact-us" />
            <NotFoundPage default />
            <OurImpact path="/:locale/our-impact" />
            <Redirect path="/:locale/our-projects" to="/:locale/our-impact" />
            <SEOSearchPage path="/:locale/events/:country/:location" />
            <SEOSearchPage path="/:locale/events/:country/:location/:time" />
            <SEOSearchPage path="/:locale/events/:time" />

            <ZipMoney path="/:locale/zipmoney" />
            <OzHarvest path="/au/our-impact/ozharvest" />
            <RoomToRead path="/:locale/our-impact/room-to-read" />
            <Yalari path="/au/our-impact/yalari" />
            <KidsCan path="/nz/our-impact/kidscan" />
            <Manaiakalani path="/nz/our-impact/manaiakalani" />

            <Home path="/" />
            <AboutUs path="/about-us" />
            <FindEventsPage path="/find-events" />
            <SearchResultsPage path="/search" />
            <ZipMoney path="/zipmoney" />
            <OurStories path="/our-stories" />
            <BuyerSupport path="/contact-us/buyer-support" />
            <OrganiserSupport path="/contact-us/organiser-support" />
            <GeneralSupport path="/contact-us/general-support" />
            <ContactUs path="/contact-us" />
            <NotFoundPage default />
            <OurImpact path="/our-impact" />
            <OzHarvest path="/our-impact/ozharvest" />
            <RoomToRead path="/our-impact/room-to-read" />
            <Yalari path="/our-impact/yalari" />

            {env === "Local" ? (
              <IframeTest path="/au/jakes-super-secret-test-page" />
            ) : (
              <NotFoundPage path="/au/jakes-super-secret-test-page" />
            )}
          </Router>
        </div>
      </Provider>
    );
  }
}
